import axios from 'axios';

export default {
  namespaced: true,
  state: {
    newCompany: null,
  },
  getters: {
  },
  mutations: {
    setNewCompany(state, newCompany) {
      state.newCompany = newCompany;
    },
  },
  actions: {
    async retrieveAllCompanies(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const companies = await axios.get('/autodesk/bim-360/account-admin/companies', config);
        return companies.data;
      } catch (error) {
        throw error;
      }
    },
    async addCompany({ commit }, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const newCompany = await axios.post('/autodesk/bim-360/account-admin/companies', data.newCompany, config);
        commit('setNewCompany', newCompany.data);
        return newCompany.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
